import { SystemStyleObject } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';

const emptyStateRootSx: SystemStyleObject = {
  position: 'relative',
  flexDirection: 'column',
  h: '180px',
  mt: 4,
  mr: 6,
  rounded: 6,
  bg: 'M.20',
  textAlign: 'center',
  justifyContent: 'center',
};

const emptyStateBtnSx: SystemStyleObject = {
  position: 'absolute',
  top: 4,
  right: 4,
  color: 'textSubdued',
};

const sidebarWidth = '6px';
const contentSx = {
  py: 2,
  pr: 6,
  ml: -3,
  overflowX: 'auto',
  overflowY: 'visible',

  '&::-webkit-scrollbar-track': {
    bg: 'transparent',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    bg: transparentize('M.60', 0.18),
    ':hover': {
      bg: transparentize('M.60', 0.54),
    },
    ':focus': {
      bg: transparentize('M.60', 0.72),
    },
  },

  // Support for older browsers & safari
  '&::-webkit-scrollbar': {
    maxWidth: sidebarWidth,
    maxHeight: sidebarWidth,
  },
};

const linkSx: SystemStyleObject = {
  position: 'relative',
  p: 2,
  textDecoration: 'none',
  _focus: {
    textDecoration: 'none',
  },
  rounded: 6,
  _hover: {
    transform: 'scale(1.02)',
    bg: 'M.20',
    ' button': {
      opacity: 1,
    },
  },
  _active: {
    transform: 'scale(0.97)',
  },
  _focusVisible: {
    boxShadow: 'none',
  },
  w: '144px',
};

const iconBtnSx: SystemStyleObject = {
  color: 'iconBase',
  position: 'absolute',
  rounded: 'full',
  bg: 'M.20',
  top: 3,
  right: 3,
  opacity: 0,
  transition: 'opacity 400ms ease-in-out',
  '& svg': {
    m: 1,
  },
};

const textSx: SystemStyleObject = {
  color: 'textBase',
  fontWeight: 'normal',
  fontSize: 'sm',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  textDecoration: 'none',
};

const getPinnedSongItemSx = (
  isOver: boolean,
  isLeft: boolean
): SystemStyleObject => {
  const px = 1;
  const dragLine = {
    content: '""',
    w: '1px',
    h: 'full',
    bg: 'B.0',
  };

  if (!isOver) {
    return { px };
  }

  if (isLeft) {
    return {
      px,
      _before: {
        ...dragLine,
        mr: 2,
      },
    };
  }

  return {
    px,
    _after: {
      ...dragLine,
      ml: 2,
    },
  };
};

export {
  emptyStateRootSx,
  emptyStateBtnSx,
  contentSx,
  textSx,
  linkSx,
  iconBtnSx,
  getPinnedSongItemSx,
};
